module.exports = __webpack_public_path__ + "img/ce474d42d65001499530b614abe7c7ea.jpg";